<template>
  <section class="text-center mx-auto">
    <div class="flex flex-col">
      <button-option
        v-for="(option, index) in $store.state.data.Steps[$store.state.activeStep]
          .Options"
        :isActive="isActiveStep(index)"
        :key="option.Id"
        @click.native="
          setSelectedTile(index);
          setUserInput({
            [$store.state.data.Steps[$store.state.activeStep]
              .SalesforcePropertyKey]: option.SalesforcePropertyValue
          });
          setNextStep();
        "
      >
        {{ option.Title }}
      </button-option>
    </div>
  </section>
</template>

<script>
import ButtonOption from "../shared/ButtonOption";
import { mapGetters } from "vuex";

export default {
  components: {
    ButtonOption
  },
  computed: {
    ...mapGetters([
      "getActiveStepId"
    ]),
  },
  methods: {
    setNextStep() {
      this.$store.commit("nextStep");
    },
    setUserInput(data) {
      this.$store.commit("updateUserInput", data);
    },
    setSelectedTile(index) {
      this.$store.commit("setSelectedTileIndex", index);
      this.$store.commit("setActiveSelection");
    },
    isActiveStep(index) {
      const selectedKey = this.$store.state.activeSelection[this.getActiveStepId];
      return (selectedKey == index) ? true : false;
    }
  }
};
</script>
